import { EventEmitter, Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventEmitterService {

  invokeFirstComponentFunction = new EventEmitter();  
  invokeGetPackagesAssociated  = new EventEmitter();  
  subsVar: Subscription;   

  constructor() { }

  onDependecyResolved(obj,cacheLabel){
    // TO DO
    /* debugger; */
    let sentObj = {
      cacheLabel: cacheLabel,
      obj: obj
    }
    if(cacheLabel == 'getCotizacion'){
      this.invokeGetPackagesAssociated.emit(obj);
    }
    this.invokeFirstComponentFunction.emit(sentObj);
  }

  onChangeCardStatus(obj) {    
    this.invokeFirstComponentFunction.emit(obj);    
  }
}
